/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


document.addEventListener('DOMContentLoaded', function () {
    let accordianButtons = document.querySelectorAll('.accordian_button');

    accordianButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const description = button.nextElementSibling;
            document.querySelectorAll('.accordian-description').forEach((desc) => {
                if (desc !== description) {
                    desc.classList.remove('active');
                }
            });

            if (description) {
                description.classList.toggle('active');
            }
        });
    });

    document.querySelectorAll('.product-gallery__thumbnail-wrapper--slider').forEach((wrapper) => {
        const scroller = wrapper.querySelector('.scroller__inner');
        const prevBtn = wrapper.querySelector('[data-direction="prev"]');
        const nextBtn = wrapper.querySelector('[data-direction="next"]');
        if (!scroller || !prevBtn || !nextBtn) return;

        const updateArrowState = () => {
            const maxScroll = scroller.scrollWidth - scroller.clientWidth;
            const atStart = scroller.scrollLeft <= 1;
            const atEnd = scroller.scrollLeft >= maxScroll - 1;
            prevBtn.classList.toggle('is-disabled', atStart);
            nextBtn.classList.toggle('is-disabled', atEnd);
            const hasOverflow = maxScroll > 1;
            prevBtn.style.display = hasOverflow ? '' : 'none';
            nextBtn.style.display = hasOverflow ? '' : 'none';
        };

        const scrollByAmount = (direction) => {
            const firstThumb = scroller.querySelector('.product-gallery__thumbnail');
            const step = firstThumb ? (firstThumb.offsetWidth + 8) * 3 : scroller.clientWidth * 0.8;
            scroller.scrollBy({ left: direction === 'next' ? step : -step, behavior: 'smooth' });
        };

        prevBtn.addEventListener('click', () => scrollByAmount('prev'));
        nextBtn.addEventListener('click', () => scrollByAmount('next'));
        scroller.addEventListener('scroll', updateArrowState, { passive: true });
        window.addEventListener('resize', updateArrowState);
        updateArrowState();
    });
});

